import Lottie from 'lottie-react'
import Money from '@/assets/lottie/money.json'

const LoadingScreen = () => {
    return (
        <div className="flex items-center justify-center w-screen h-screen">
            <Lottie animationData={Money} className="md:w-1/4" />
        </div>
    )
}

export default LoadingScreen
